import { api } from '../client';

export const spark = {
  createGi: api.createGi,
};
